module Registration {
    declare var apiUrl: string;


    $(() => {
        /*$("#btnRegister").click(() => {
            $("#welcome").hide();
            $("#registration").show();
        });
        */
        /*
        $("#btnRegisterCompany").click(() => {
            // data-source="2" data-binding = ""
        });

        
        $("#btnRegisterConsumer").click(() => {
            $("data-source=1").each((i, e) => {
                var el = $(e);
                var property = el.attr("data-binding");
                var value = el.val();
                console.log("property: " + property + " value: " + value);
            });
            /*userManagementHubCaller.executeOperation("saveWebUserRegistration").success(function (approved) {
                $.unblockUI();
                if (approved) {
                    window.location.href = window.AuthPage;
                }
                else {
                    window.location.href = window.ManualRegistrationPage;
                }
            });*/
        //});
    });

}